module.exports = __webpack_public_path__ + "static/media/mx.4143a6ea.png";